import { createActionConst } from '../../../utils/action.utils';

const PROJECT_NAMESPACE = 'PROJECT';

export const STORE_PROJECT = createActionConst(PROJECT_NAMESPACE, 'STORE_PROJECT');
export const CLEAR_PROJECT = createActionConst(PROJECT_NAMESPACE, 'CLEAR_PROJECT');
